import { render, staticRenderFns } from "./SideBlogs.vue?vue&type=template&id=abd669f2"
import script from "./SideBlogs.vue?vue&type=script&lang=js"
export * from "./SideBlogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports